import { pyrotchBaseUrl, axiosBaseQuery } from "../axios/AxiosInstance";
import { createApi } from "@reduxjs/toolkit/query/react";
import { User, UserDataResponse } from "../../models/User";

export const UserApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "userCreationApi",
  tagTypes: ["User"],
  endpoints(build) {
    return {
      registerUser: build.mutation<any, User>({
        query: (userData) => ({
          url: `admin/user/register/user`,
          method: "POST",
          data: userData,
        }),
        invalidatesTags: ["User"],
      }),
      updateUser: build.mutation<any, User>({
        query: (userData) => ({
          url: `admin/user/update/user`,
          method: "PUT",
          data: userData,
        }),
        invalidatesTags: ["User"],
      }),
      getUsers: build.query<UserDataResponse, { page: number; size: number }>({
        query: ({ page, size }) => ({
          url: `admin/user/all?page=${page}&size=${size}`,
          method: "GET",
        }),
        providesTags: ["User"],
      }),
      getUsersSearch: build.query<
        UserDataResponse,
        { page: number; size: number; search: string }
      >({
        query: ({ page, size, search }) => ({
          url: `user/search?page=${page}&size=${size}&search=${search}`,
          method: "GET",
        }),
      }),
      getUserRole: build.query<{ id: number; name: string }[], void>({
        query: () => ({
          url: `user/roles/all`,
          method: "GET",
        }),
      }),
      changePassword: build.mutation<any, { id: number; newPassword: string }>({
        query: ({ id, newPassword }) => ({
          url: `admin/user/change-password?id=${id}&newPassword=${newPassword}`,
          method: "POST",
        }),
      }),
      deleteUser: build.mutation<any, number>({
        query: (id) => ({
          url: `admin/user/${id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["User"],
      }),
      userbyRole: build.query<any, string>({
        query: (roles) => ({
          url: `admin/user/by-roles?roles=${encodeURIComponent(roles)}`,
          method: "GET",
          param: { roles: encodeURIComponent(roles) },
        }),
      }),
    };
  },
});

export const {
  useRegisterUserMutation,
  useGetUsersQuery,
  useGetUsersSearchQuery,
  useLazyGetUsersSearchQuery,
  useUpdateUserMutation,
  useGetUserRoleQuery,
  useChangePasswordMutation,
  useDeleteUserMutation,
  useLazyUserbyRoleQuery,
} = UserApi;
